module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074a9_logo_200x200.fa302e26.png";